import ReadMoreDocsLink from "components/ReadMoreDocsLink";
import TooltipModalBody from "ds/components/TooltipModal/Body";
import { TooltipModalTitle } from "ds/components/TooltipModal/Title";
import { getDocsUrl } from "utils/getDocsUrl";

const FormFieldGitSparseCheckoutPathsTooltip = () => (
  <>
    <TooltipModalTitle>Git sparse checkout paths</TooltipModalTitle>
    <TooltipModalBody align="start">
      Git sparse checkout allows you to check out only a subset of files from a repository, rather
      than the entire working directory. This is particularly useful for large repositories where
      you only need to work with specific directories or files.
      <ReadMoreDocsLink docsUrl={getDocsUrl("/concepts/stack/stack-settings#project-globs")} />
    </TooltipModalBody>
  </>
);

export default FormFieldGitSparseCheckoutPathsTooltip;
